/**
 * @generated SignedSource<<42df5521404ed164938e72fba10e8d0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type TeamNavigator_store$data = {
  readonly id: string;
  readonly myRole: Roles;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_store" | "TeamHomeNavigator_store" | "TeamPickerPopover_store">;
  readonly " $fragmentType": "TeamNavigator_store";
};
export type TeamNavigator_store$key = {
  readonly " $data"?: TeamNavigator_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamNavigator_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamNavigator_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "myRole",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamPickerPopover_store"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHomeNavigator_store"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHeader_store"
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "ac4659e406f5a0278f718b716eacfbff";

export default node;
